import { Globe, ExternalLink } from 'lucide-react'
import './TargetUrlBadge.css'

/**
 * The "Target URL" indicator shown near the top of every task-detail page (version, journey,
 * exploration). It names the deployed app URL the QA ran against and links out to it, so a reader
 * can immediately see — and open — what was tested. Render nothing when no URL is known.
 */
export default function TargetUrlBadge({ url, testId }: { url: string; testId?: string }) {
  return (
    <a
      className="target-url-badge"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      data-analytics-event="task-target-url"
    >
      <Globe size={13} aria-hidden className="target-url-badge__icon" />
      <span className="target-url-badge__label">Target</span>
      <span className="target-url-badge__url">{url}</span>
      <ExternalLink size={12} aria-hidden className="target-url-badge__ext" />
    </a>
  )
}
